<template>
  <el-dialog
      :visible.sync="dialogVisible"
      append-to-body
      title="选择产品"
      class="customer-edit"
      width="800px"
      top="5vh">
    <vm-table
        ref="vmTable"
        :filter.sync="filter"
        module="basic"
        url="materials/pageList"
        method="post">
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="关键字">
            <el-input v-model.trim="filter.filter" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="materialNO" label="产品编号" width="100"/>
      <el-table-column prop="materialName" label="产品名称"/>
      <el-table-column prop="outerNO" label="物料编号" width="100"/>
      <el-table-column label="操作" align="center" width="100px">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="onSelect(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </vm-table>
  </el-dialog>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";


  export default {
    name: "ProductSelect",
    components: {VmTable, VmSearch},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        idList: "",
        filter: {
          filter: "",
        },
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.vmTable.getList(1);
        });
      },
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      onSelect(row) {
        this.$emit("select", row);
        this.dialogVisible = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
